// Date / time helpers — formatting, components, stamps.

export function createDateTimeStamp() {
  const date = new Date();
  const date_time_stamp =
    date.getMonth() +
    1 +
    '/' +
    date.getDate() +
    '/' +
    date.getFullYear() +
    ' ' +
    date.getHours() +
    ':' +
    date.getMinutes() +
    ':' +
    date.getSeconds();
  return date_time_stamp;
}

export function createDateStamp() {
  const date = new Date();
  const date_stamp =
    date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
  return date_stamp;
}

export function getDay(date_value?: Date): string {
  if (date_value) {
    const day = ('0' + date_value.getDate()).slice(-2);
    return day;
  } else {
    // If no date_value is provided, use the current date
    const date = new Date();
    const day = ('0' + date.getDate()).slice(-2);
    return day;
  }
}

export function getMonth(date_value?: Date): string {
  if (date_value) {
    const month = ('0' + (date_value.getMonth() + 1)).slice(-2);
    return month;
  } else {
    // If no date_value is provided, use the current date
    const date = new Date();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    return month;
  }
}

export function getYear(date_value?: Date): string {
  if (date_value) {
    const year = date_value.getFullYear().toString();
    return year;
  } else {
    // If no date_value is provided, use the current date
    const date = new Date();
    const year = date.getFullYear().toString();
    return year;
  }
}

export function dateFormatter(params) {
  const date = new Date(params.value);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}

export function dateTimeFormatter(params) {
  const date = new Date(params.value);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
}

export function datePartitioner(date: string, return_type: string) {
  date = date.replace(/-/g, '');
  const year = date.slice(4, 8);
  const month = date.slice(0, 2);
  const day = date.slice(2, 4);
  if (return_type === 'm') {
    return `${month}`;
  } else if (return_type === 'd') {
    return `${day}`;
  } else {
    return `${year}`;
  }
}

export function createDateFromComponents(
  month: string | number,
  day: string | number,
  year: string | number,
): Date {
  const y = typeof year === 'string' ? parseInt(year, 10) : year;
  const m = typeof month === 'string' ? parseInt(month, 10) : month;
  const d = typeof day === 'string' ? parseInt(day, 10) : day;
  return new Date(y, m - 1, d);
}

export function isToday(): Date {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

/** Renders an ISO timestamp as "just now" / "5 minutes ago" / "3 days ago", falling
 *  back to a plain date once it's further out than a month. */
export function timeAgo(isoDate: string | null | undefined): string {
  if (!isoDate) return '';
  const then = new Date(isoDate).getTime();
  if (Number.isNaN(then)) return '';

  const seconds = Math.floor((Date.now() - then) / 1000);
  if (seconds < 30) return 'just now';

  const units: [number, string][] = [
    [60, 'second'],
    [60, 'minute'],
    [24, 'hour'],
    [30, 'day'],
  ];
  let value = seconds;
  for (const [size, label] of units) {
    if (value < size) {
      const rounded = Math.floor(value);
      return `${rounded} ${label}${rounded === 1 ? '' : 's'} ago`;
    }
    value /= size;
  }
  return new Date(isoDate).toLocaleDateString();
}
